import { Droppable, Draggable } from "@hello-pangea/dnd";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { checkAccessPermission } from "../../utils/utilityFunctions/localServices";
import { INITIAL_INPUTS } from "./extras/Constants";
import { truncateString } from "../../utils/utilityFunctions/stringUtility";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import InfoButton from "../UniversalComponents/InfoButton";
import { ReactComponent as UploadSvg } from "../../assets/images/upload.svg";

const Section = ({ section, index, onEditSection, onDeleteSection, onEditInput, onDeleteInput }) => {
  return (
    <Draggable draggableId={section.sectionId} index={index}>
      {(provided) => (
        <div ref={provided.innerRef} {...provided.draggableProps} className="rounded px-4">
          <div className="flex gap-3 items-center group min-h-10 border-b border-b-[#DFE2E5] text-[#0c0c0ca1]">
            <h3 {...provided.dragHandleProps} className="font-semibold cursor-grab  ">
              {section.sectionName}
              {section?.sectionInfo && <InfoButton size="small" content={section?.sectionInfo} />}
            </h3>
            {checkAccessPermission("Add & Manage Groups & Permission") && (
              <div className="gap-1 hidden group-hover:flex">
                <IconButton onClick={() => onEditSection(section)}>
                  <EditIcon className="text-indigo-700 opacity-90" fontSize="small" />
                </IconButton>
                {!section?.sectionIsEditable && (
                  <IconButton onClick={() => onDeleteSection(section.sectionId)}>
                    <DeleteIcon className="text-red-700 opacity-90" fontSize="small" />
                  </IconButton>
                )}
              </div>
            )}
          </div>
          <Droppable droppableId={section.sectionId} type="INPUT">
            {(provided, snapshot) => {
              const isDraggingOver = snapshot.isDraggingOver;
              return (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className={`min-h-[50px] grid ${section.inputs.length === 0 ? "grid-cols-1" : "grid-cols-2"} gap-2 transition-colors duration-200 p-3
                ${isDraggingOver ? "bg-primary-hover border-2 border-primary" : "bg-white border border-transparent"}`}
                >
                  {section.inputs.map((input, idx) => (
                    <Draggable
                      isDragDisabled={!input?.inputIsEditable}
                      key={input?.inputId}
                      draggableId={input?.inputId}
                      index={idx}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="flex gap-3 w-full h-fit border-[1px] rounded cursor-pointer items-center group"
                        >
                          <p className="w-1/4 h-full p-2 flex items-center bg-primary-active text-[#131313CC] text-sm">
                            {truncateString({ str: input?.inputValue })}
                            {input?.inputInfo && <InfoButton size="small" content={input?.inputInfo} />}
                          </p>

                          <div className="flex justify-between min-w-0 grow items-center bg-white">
                            <div>
                              <span className="text-gray-500 text-sm">
                                {INITIAL_INPUTS.find(
                                  (inputData) => inputData.inputType === input?.inputMeta?.absoluteType
                                )?.inputName || "Text"}
                              </span>
                              {/* <span className="p-2 rounded-full bg-green-500">tm</span> */}
                            </div>

                            {checkAccessPermission("Add & Manage Groups & Permission") && (
                              <div className="gap-2 hidden group-hover:flex">
                                {input?.inputValue !== "Title" && (
                                  <IconButton
                                    size="small"
                                    onClick={() => onEditInput(section?.sectionId, section?.sectionName, input)}
                                  >
                                    <EditIcon className="text-indigo-700 opacity-90" fontSize="small" />
                                  </IconButton>
                                )}
                                <IconButton size="small" onClick={() => onDeleteInput(input.inputId)}>
                                  <DeleteIcon className="text-red-700 opacity-90" fontSize="small" />
                                </IconButton>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                  {section.inputs.length === 0 && (
                    <div className="flex flex-col justify-center text-primary gap-3 p-4 border-2 group items-center border-dashed border-[#D2DAE1] cursor-pointer rounded-md mt-4">
                      <UploadSvg className="fill-current" />
                      <p className="text-[#66666699] group-hover:opacity-70">Drop for fields here</p>
                    </div>
                  )}
                </div>
              );
            }}
          </Droppable>
        </div>
      )}
    </Draggable>
  );
};

export default Section;
